import { useMemo, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import routes from "@/routes";

import { Menu } from "antd";

import TaskIcon from "@/icons/TaskIcon";
import ArchiveIcon from "@/icons/ArchiveIcon";
import StructureIcon from "@/icons/StructureIcon";
import ChevronDownIcon from "@/icons/ChevronDownIcon";
import ChevronUp from "@/icons/ChevronUpIcon";
import StarIcon from "@/icons/StarIcon";
import FolderOpenIcon from "@/icons/FolderOpenIcon";
import ChartSquareBarIcon from "@/icons/ChartSquareBarIcon";
import ClipboardIcon from "@/icons/ClipboardIcon";
import CubIcon from "@/icons/CubIcon";
import UserGroupIcon from "@/icons/UserGroupIcon";
import BookmarkAltIcon from "@/icons/BookmarkAltIcon";
import IdentificationIcon from "@/icons/IdentificationIcon";
import SettingsIcon from "@/icons/SettingsIcon";
import CollectionIcon from "@/icons/CollectionIcon";
import CalendarIcon from "@/icons/CalendarIcon";
import ChatAltIcon from "@/icons/ChatAltIcon";
import TextTableHistory from "@/icons/TextTableHistory";
import DocumentSearchIcon from "@/icons/DocumentSearchIcon";
import MapIcon from "@/icons/MapIcon";
import FlagIcon from "@/icons/FlagIcon";
import TableIcon from "@/icons/TableIcon";

import { UserContext } from "@/context/UserContext";

// Список доступных разделов
const PAGES = [
  {
    key: "units",
    icon: <StarIcon />,
    label: <div title="Рабочие группы">Рабочие группы</div>,
    // label: <Link to={routes.units}>Рабочие группы</Link>,
  },
  {
    key: "tasks",
    // icon: <ReconciliationTwoTone />,
    icon: <TaskIcon />,
    label: <div title="Задачи">Задачи</div>,
    children: [
      {
        key: "t-list",
        title: "Список задач",
        label: <Link to={routes.tasks}>Список задач</Link>,
      },
      {
        key: "t-templates",
        title: "Шаблоны задач",
        label: <Link to={routes.taskTemplates}>Шаблоны задач</Link>,
      },
    ],
  },
  {
    key: "calendar",
    icon: <CalendarIcon />,
    title: "Календарь",
    label: <Link to={routes.calendar()}>Календарь</Link>,
  },
  {
    key: "sprints",
    icon: <FlagIcon />,
    title: "Спринты",
    label: <Link to={routes.sprints}>Спринты</Link>,
  },
  {
    key: "documents",
    icon: <ArchiveIcon />,
    title: "Документы",
    label: "Документы",
  },
  {
    key: "requests",
    icon: <ClipboardIcon />,
    label: <div title="Заявки">Заявки</div>,
    children: [
      {
        key: "my-requests",
        title: "Мои заявки",
        label: <Link to={routes.myRequests}>Мои заявки</Link>,
      },
      {
        key: "request-registration",
        title: "Регистрация заявки",
        label: <div title="Регистрация заявки">Регистрация заявки</div>,
      },
    ],
  },
  //
  {
    key: "my-objects",
    // icon: <PieChartTwoTone />,
    icon: <CubIcon />,
    label: <div title="Ресурсы">Ресурсы</div>,
  },
  {
    key: "map-view",
    icon: <MapIcon />,
    title: "Карта с ресурсами",
    label: <Link to={routes.mapView}>Карта</Link>,
  },
  {
    key: "files",
    icon: <FolderOpenIcon />,
    title: "Файлы",
    label: <Link to={routes.folder()}>Файлы</Link>,
  },
  {
    key: "company-structure",
    icon: <StructureIcon />,
    title: "Структура компании",
    label: <Link to={routes.companyStructure}>Структура компании</Link>,
  },
  {
    key: "custom-reports",
    icon: <DocumentSearchIcon />,
    label: <div title="Отчеты">Отчеты</div>,
  },
  {
    key: "analytics",
    icon: <ChartSquareBarIcon />,
    label: <div title="Аналитические отчеты">Аналитические отчеты</div>,
  },
];

const ADMIN_PAGES = [
  {
    key: "employees",
    icon: <IdentificationIcon />,
    label: <div title="Сотрудники">Сотрудники</div>,
    children: [
      {
        key: "e-list",
        title: "Список сотрудников",
        label: <Link to={routes.administration.employeeList}>Список</Link>,
      },
      {
        key: "time-tracking",
        title: "Табель",
        label: <Link to={routes.administration.timeTracking}>Табель</Link>,
      },
    ],
  },
  {
    key: "guides",
    icon: <BookmarkAltIcon />,
    label: <div title="Системные справочники">Системные справочники</div>,
    children: [
      {
        key: "positions",
        title: "Список должностей",
        label: (
          <Link to={routes.administration.guides.positions}>Должности</Link>
        ),
      },
      {
        key: "unit-types",
        title: "Список типов рабочих групп",
        label: (
          <Link to={routes.administration.guides.unitTypes}>
            Типы рабочих групп
          </Link>
        ),
      },
      {
        key: "priorities",
        title: "Список приоритетов задач",
        label: (
          <Link to={routes.administration.guides.priorities}>
            Приоритеты задач
          </Link>
        ),
      },
      {
        key: "statuses",
        title: "Список статусов задач ",
        label: (
          <Link to={routes.administration.guides.statuses}>Статусы задач</Link>
        ),
      },
      {
        key: "task-types",
        title: "Список типов задач",
        label: (
          <Link to={routes.administration.guides.taskTypes}>Типы задач</Link>
        ),
      },
      {
        key: "sprint-statuses",
        title: "Статусы спринтов",
        label: (
          <Link to={routes.administration.guides.sprintStatuses}>
            Статусы спринтов
          </Link>
        ),
      },
    ],
  },
  {
    key: "all-units",
    icon: <StructureIcon />,
    title: "Настройка рабочих групп",
    label: <Link to={routes.administration.units}>Рабочие группы</Link>,
  },
  {
    key: "users",
    icon: <UserGroupIcon />,
    title: "Управление пользователями",
    label: <Link to={routes.administration.users}>Пользователи</Link>,
  },
  {
    key: "all-tasks",
    icon: <TaskIcon />,
    label: <div title="Задачи">Задачи</div>,
    children: [
      {
        key: "all-t-list",
        title: "Все задачи",
        label: <Link to={routes.administration.tasks}>Список задач</Link>,
      },
      {
        key: "all-t-templates",
        title: "Все шаблоны задач",
        label: (
          <Link to={routes.administration.taskTemplates}>Шаблоны задач</Link>
        ),
      },
    ],
  },
  {
    key: "all-sprints",
    icon: <FlagIcon />,
    title: "Спринты",
    label: <Link to={routes.administration.sprints}>Спринты</Link>,
  },
  {
    key: "all-objects",
    icon: <CubIcon />,
    label: <div title="Все ресурсы">Ресурсы</div>,
  },
  {
    key: "all-files",
    icon: <FolderOpenIcon />,
    title: "Каталог файлов",
    label: <Link to={routes.administration.folder()}>Файлы</Link>,
  },
  {
    key: "resources",
    icon: <CollectionIcon />,
    label: (
      <div title="Управление структурой ресурсов">
        Структура ресурсов
      </div>
    ),

    children: [
      {
        key: "objects",
        title: "Управление типами объектов",
        label: (
          <Link
            to={routes.administration.resourcesSettings.structures.definitions(
              "objects",
            )}
          >
            Типы объектов
          </Link>
        ),
      },
      {
        key: "repositories",
        title: "Управление справочниками",
        label: (
          <Link
            to={routes.administration.resourcesSettings.structures.definitions(
              "repositories",
            )}
          >
            Справочники
          </Link>
        ),
      },
      {
        key: "templates",
        title: "Управление шаблонами",
        label: (
          <Link
            to={routes.administration.resourcesSettings.structures.definitions(
              "templates",
            )}
          >
            Шаблоны
          </Link>
        ),
      },
    ],
  },
  {
    key: "nspd-settings",
    icon: <TableIcon />,
    title: "Настройки ключей НСПД",
    label: (
      <Link to={routes.administration.NSPDSettings}>Настройки ключей НСПД</Link>
    ),
  },
  {
    key: "system-settings",
    icon: <SettingsIcon />,
    title: "Настройки системы",
    label: (
      <Link to={routes.administration.systemSettings}>Настройки системы</Link>
    ),
  },
  {
    key: "notice-settings",
    icon: <ChatAltIcon />,
    title: "Настройки уведомлений",
    label: (
      <Link to={routes.administration.noticeSettings}>
        Настройки уведомлений
      </Link>
    ),
  },
  {
    key: "system-logging",
    icon: <TextTableHistory />,
    title: "Список изменений объектов системы",
    label: <Link to={routes.administration.systemLogging}>Системные логи</Link>,
  },
];

const findNavByName = (navs, targetName) => {
  for (const nav of navs) {
    if (nav.name === targetName) {
      return nav;
    }

    if (nav.objects) {
      const foundInObjects = findNavByName(nav.objects, targetName);
      if (foundInObjects) {
        return foundInObjects;
      }
    }

    if (nav.folders) {
      const foundInFolders = findNavByName(nav.folders, targetName);
      if (foundInFolders) {
        return foundInFolders;
      }
    }
  }

  return null; // Если ничего не найдено
};

const getRequestRegistrationPath = (request) => {
  const units = request?.units || [];

  if (units.length !== 1) {
    return routes.requestRegistration(request.uuid);
  }

  return routes.requestForm(
    request.uuid,
    units[0].unit_uuid,
    request.access_mode === "public",
  );
};

const hasSingleRequestUnit = (request) => (request?.units || []).length === 1;

// Меню в левой части страницы
// Содержит ссылки на разделы приложения
const MenuNav = ({
  resources,
  units,
  analyticReports,
  requests,
  reports,
  isAdmin = false,
  config,
}) => {
  const location = useLocation(); // пока подходит, если задавать путь используя уникальный key

  const { user } = useContext(UserContext);

  const formateMenu = useMemo(() => {
    if (!user) return [];

    let pages = isAdmin ? [...ADMIN_PAGES] : [...PAGES];
    const sprintsLabel = config?.entities?.sprint?.name?.plural || "Спринты";
    const sprintStatusesLabel =
      config?.entities?.sprint?.ui?.statusesTitle || "Статусы спринтов";

    const formateNavs = ({ navs, unit_uuid, isAdmin = false }) => {
      // const temp = unit_uuid
      //   ? navs.filter(({ definition_type }) => definition_type !== "repository")
      //   : navs;

      return navs.map((nav) => {
        const folders = nav.folders
          ? formateNavs({ navs: nav.folders, unit_uuid, isAdmin })
          : null;

        // .filter(
        //   ({ definition_type }) => definition_type !== "repository"
        // )

        const objects = nav.objects
          ? nav.objects.map((object) => ({
              key: unit_uuid
                ? `${unit_uuid}-${object.uuid}`
                : isAdmin
                  ? `a-${object.uuid}`
                  : object.uuid,
              title: object.name,
              label: unit_uuid ? (
                <Link to={routes.unitObjectList(unit_uuid, object.child)}>
                  {object.name}
                </Link>
              ) : isAdmin ? (
                <Link to={routes.administration.objectList(object.child)}>
                  {object.name}
                </Link>
              ) : (
                <Link to={routes.objectList(object.child)}>{object.name}</Link>
              ),
            }))
          : null;

        const children = folders
          ? objects
            ? [...folders, ...objects]
            : folders
          : objects;

        return {
          key: unit_uuid
            ? `${unit_uuid}-${nav.uuid}`
            : isAdmin
              ? `a-${nav.uuid}`
              : nav.uuid,
          title: nav.name,
          label:
            nav.type === "folder" ? (
              <div title={nav.name}>{nav.name}</div>
            ) : unit_uuid ? (
              <Link to={routes.unitObjectList(unit_uuid, nav.child)}>
                {nav.name}
              </Link>
            ) : isAdmin ? (
              <Link to={routes.administration.objectList(nav.child)}>
                {nav.name}
              </Link>
            ) : (
              <Link to={routes.objectList(nav.child)}>{nav.name}</Link>
            ),
          children,
        };
      });
    };

    if (isAdmin) {
      // Форматируем навигацию для объектов

      const allResNavIdx = pages.findIndex(
        (page) => page.key === "all-objects",
      );
      if (allResNavIdx)
        pages[allResNavIdx].children = formateNavs({
          navs: resources,
          isAdmin: true,
        });
    } else {
      // Форматируем навигацию для объектов
      const resNavIdx = pages.findIndex((page) => page.key === "my-objects");
      pages[resNavIdx].children = formateNavs({ navs: resources });

      // Форматируем навигацию для рабочих групп
      const unitsNavIdx = pages.findIndex((page) => page.key === "units");
      // Найти личную группу
      const personalUnit = units.find((unit) => unit.unit_type?.is_personal);
      // Отфильтровать остальные
      const otherUnits = units.filter((unit) => !unit.unit_type?.is_personal);
      // Собрать итоговый массив: сначала личная, потом остальные
      const orderedUnits = personalUnit
        ? [personalUnit, ...otherUnits]
        : otherUnits;

      pages[unitsNavIdx].children = orderedUnits.map((unit) => {
        const children = [
          {
            key: `${unit.uuid}-tasks`,
            label: <div title="Задачи">Задачи</div>,
            children: [
              {
                key: `${unit.uuid}-tasks-list`,
                title: "Список задач",
                label: (
                  <Link to={routes.unitTasks(unit.uuid)}>Список задач</Link>
                ),
              },
              {
                key: `${unit.uuid}-tasks-templates`,
                title: "Шаблоны задач",
                label: (
                  <Link to={routes.unitTaskTemplates(unit.uuid)}>
                    Шаблоны задач
                  </Link>
                ),
              },
            ],
          },
          {
            key: `${unit.uuid}-calendar`,
            title: "Календарь",
            label: <Link to={routes.unitCalendar(unit.uuid)}>Календарь</Link>,
          },
          {
            key: `${unit.uuid}-sprints`,
            title: sprintsLabel,
            label: (
              <Link to={routes.unitSprints(unit.uuid)}>{sprintsLabel}</Link>
            ),
          },
          {
            key: `${unit.uuid}-files`,
            title: "Файлы",
            label: <Link to={`${routes.unitFolder(unit.uuid)}`}>Файлы</Link>,
          },
        ];

        if (unit.unit_type?.is_hierarchical) {
          children.push({
            key: `${unit.uuid}-my-objects`,
            label: <div title="Ресурсы">Ресурсы</div>,
            children: formateNavs({
              navs: resources,
              unit_uuid: unit.uuid,
            }),
          });
        }

        if (!unit.unit_type?.is_personal) {
          children.push({
            key: `${unit.uuid}-members`,
            title: "Участники",
            label: (
              <Link to={`${routes.unitMembers(unit.uuid)}`}>Участники</Link>
            ),
          });
        }

        return {
          key: unit.uuid,
          label: <div title={unit.name}>{unit.name}</div>,
          children,
        };
      });

      // Временная ссылка на документы
      const targetNav = findNavByName(resources, "Договоры аренды");
      const docsNavIdx = pages.findIndex((page) => page.key === "documents");

      if (targetNav && docsNavIdx) {
        pages[docsNavIdx].label = (
          <Link to={routes.objectList(targetNav.child)}>Документы</Link>
        );
      }

      // Отчеты
      const reportsNavIdx = pages.findIndex(
        (page) => page.key === "custom-reports",
      );

      const reportsChildren = reports
        .sort((a, b) => a.idx - b.idx)
        .filter((report) => report.visibility)
        .map((report) => {
          return {
            key: report.uuid,
            title: report.name,
            label: (
              <Link to={routes.reportView(report.uuid)}>{report.name}</Link>
            ),
          };
        });

      if (reportsChildren.length) {
        pages[reportsNavIdx] = {
          ...pages[reportsNavIdx],
          children: reportsChildren,
        };
      } else {
        pages.splice(reportsNavIdx, 1);
      }

      // Аналитические отчеты
      const analyticsNavIdx = pages.findIndex(
        (page) => page.key === "analytics",
      );

      const analyticsChildren = analyticReports
        .sort((a, b) => a.idx - b.idx)
        .filter((report) => report.is_visible)
        .map((report) => {
          return {
            key: report.uuid,
            title: report.name,
            label: (
              <a href={report.url} target="_blank" rel="noreferrer">
                {report.name}
              </a>
            ),
          };
        });

      if (analyticsChildren.length) {
        pages[analyticsNavIdx] = {
          ...pages[analyticsNavIdx],
          children: analyticsChildren,
        };
      } else {
        pages.splice(analyticsNavIdx, 1);
      }

      // Заявки
      const requestsParentIdx = pages.findIndex(
        (page) => page.key === "requests",
      );
      const requestsParent = pages[requestsParentIdx];

      if (requestsParent) {
        let registrationIdx = requestsParent.children.findIndex(
          (child) => child.key === "request-registration",
        );

        const requestsChildren = requests
          .sort((a, b) => a.idx - b.idx)
          .filter((request) => request.is_visible)
          .map((request) => {
            const shouldOpenInNewTab = hasSingleRequestUnit(request);

            return {
              key: request.uuid,
              title: request.name,
              label: (
                <Link
                  to={getRequestRegistrationPath(request)}
                  target={shouldOpenInNewTab ? "_blank" : undefined}
                  rel={shouldOpenInNewTab ? "noopener noreferrer" : undefined}
                >
                  {request.name}
                </Link>
              ),
            };
          });

        if (registrationIdx !== -1) {
          if (requestsChildren.length) {
            requestsParent.children[registrationIdx] = {
              ...requestsParent.children[registrationIdx],
              children: requestsChildren,
            };
          } else {
            requestsParent.children.splice(registrationIdx, 1);
          }
        } else {
          registrationIdx = requestsParent.children.length;
          requestsParent.children.push({
            key: "request-registration",
            title: "Регистрация заявки",
            label: <div title="Регистрация заявки">Регистрация заявки</div>,
          });
        }
      }
    }

    // Переименование "Спринты", на имя которое задано в конфиге
    const sprintsNavIdx = pages.findIndex((page) => page.key === "sprints");

    if (sprintsNavIdx !== -1) {
      pages[sprintsNavIdx] = {
        ...pages[sprintsNavIdx],
        title: sprintsLabel,
        label: <Link to={routes.sprints}>{sprintsLabel}</Link>,
      };
    }

    const adminSprintsNavIdx = pages.findIndex(
      (page) => page.key === "all-sprints",
    );

    if (adminSprintsNavIdx !== -1) {
      pages[adminSprintsNavIdx] = {
        ...pages[adminSprintsNavIdx],
        title: sprintsLabel,
        label: <Link to={routes.administration.sprints}>{sprintsLabel}</Link>,
      };
    }

    const guidesNavIdx = pages.findIndex((page) => page.key === "guides");
    const sprintStatusesNavIdx = pages[guidesNavIdx]?.children.findIndex(
      (page) => page.key === "sprint-statuses",
    );

    if (guidesNavIdx !== -1 && sprintStatusesNavIdx !== -1) {
      pages[guidesNavIdx].children[sprintStatusesNavIdx] = {
        ...pages[guidesNavIdx].children[sprintStatusesNavIdx],
        title: sprintStatusesLabel,
        label: (
          <Link to={routes.administration.guides.sprintStatuses}>
            {sprintStatusesLabel}
          </Link>
        ),
      };
    }

    return pages;
    // eslint-disable-next-line
  }, [resources, units, analyticReports, requests, user, isAdmin]);

  const selectedKeys = useMemo(() => {
    const path = location.pathname.split("/");
    const root = path[1];
    let unit_uuid = null;

    const searchPath = ({ navs, defId, path = [], isAdmin = false }) => {
      for (const nav of navs) {
        const currentPath = [
          ...path,
          unit_uuid
            ? `${unit_uuid}-${nav.uuid}`
            : isAdmin
              ? `a-${nav.uuid}`
              : nav.uuid,
        ];

        if (nav.type === "object" && nav.child === defId) {
          return currentPath;
        }

        if (nav.folders?.length) {
          const result = searchPath({
            navs: nav.folders,
            defId,
            path: currentPath,
            isAdmin,
          });
          if (result) return result;
        }

        if (nav.objects?.length) {
          const result = searchPath({
            navs: nav.objects,
            defId,
            path: currentPath,
            isAdmin,
          });
          if (result) return result;
        }
      }
      return null;
    };

    const handleMyResources = () => {
      const defId = path.filter((item) => item && item !== "objects")[1];
      const newPath = searchPath({ navs: resources, defId });
      return newPath ? ["my-objects", ...newPath] : ["my-objects"];
    };

    const handleAllResources = () => {
      const defId = path.filter((item) => item && item !== "objects")[2];
      const newPath = searchPath({ navs: resources, defId, isAdmin: true });
      return newPath
        ? ["administration", "all-objects", ...newPath]
        : ["administration", "all-objects"];
    };

    const handleUnitPaths = (suffix) => {
      path[3] = `${path[2]}-${suffix}`;

      if (suffix === "tasks") {
        path[4] = `${path[2]}-tasks-${path[4].split("-")[2]}`;
      }
    };

    const handleUResources = () => {
      unit_uuid = path[2];
      path[3] = `${unit_uuid}-my-objects`;
      const defId = path.filter((item) => item && item !== "objects")[3];
      const newPath = searchPath({ navs: resources, defId });
      return newPath
        ? [unit_uuid, `${unit_uuid}-my-objects`, ...newPath]
        : [unit_uuid, `${unit_uuid}-my-objects`];
    };

    if (root === "my-objects") {
      return handleMyResources();
    }
    if (root === "administration" && path[2] === "all-objects") {
      return handleAllResources();
    }

    switch (path[3]) {
      case "u-tasks":
        handleUnitPaths("tasks");
        break;
      case "u-files":
        handleUnitPaths("files");
        break;
      case "u-objects":
        return handleUResources();
      case "u-members":
        handleUnitPaths("members");
        break;
      case "u-calendar":
        handleUnitPaths("calendar");
        break;
      case "u-sprints":
        handleUnitPaths("sprints");
        break;
      default:
        break;
    }

    return path;
  }, [resources, location]);

  return (
    <Menu
      mode="inline"
      items={formateMenu}
      defaultOpenKeys={selectedKeys}
      selectedKeys={selectedKeys}
      inlineIndent={10}
      expandIcon={({ isOpen }) =>
        isOpen ? <ChevronUp /> : <ChevronDownIcon />
      } // Используем разные иконки
    />
  );
};

export default MenuNav;
